import React from "react";
import { Backdrop, Box, CircularProgress, Typography } from "@mui/material";

const PdfDownloadBackdrop = ({ open, message = "Preparing PDF download..." }) => (
  <Backdrop
    open={open}
    sx={(theme) => ({
      zIndex: theme.zIndex.modal + 1,
      flexDirection: "column",
      gap: 2,
    })}
  >
    <CircularProgress color="inherit" />
    <Box component="span" sx={{ px: 2, textAlign: "center" }}>
      <Typography color="inherit">{message}</Typography>
    </Box>
  </Backdrop>
);

export default PdfDownloadBackdrop;
